import React from "react";
// COMPONENTS
import SelectLifts from "../select/SelectLifts";

export default function FormSelectLift({
	inputValue,
	inputOnChange,
	disabledInput,
}: {
	inputValue: string;
	inputOnChange: (id: string, name: string) => void;
	disabledInput: boolean;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const inputOnChangeSelect = (id: string, name: string) => {
		inputOnChange(id, name);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>Lift</span>
				</div>
				<div className='generalStyles__width100'>
					<SelectLifts inputValue={inputValue} inputOnChange={inputOnChangeSelect} disabledInput={disabledInput} />
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
